@if (course) {
  @if (mode == 'mobile') {
    <div class="dialog-container">
      <div class="list-column">
        <app-logo/>
        <div class="typo-h1 spacing-top">{{ 'courses.selection' | transloco }}</div>
        <div class="typo-h1 spacing-top">{{ course.title }}</div>
        <div class="label spacing-top">
          <mat-icon>home</mat-icon>
          <div class="body-text-bold">{{ locationInfo() }}</div>
        </div>
        <div class="label spacing-top">
          <mat-icon>calendar_today</mat-icon>
          <div class="body-text-bold">{{ (selectedAppointments.length > 1 ? 'courses.appointments' : 'courses.appointment') | transloco }}
          </div>
        </div>
        <div class="appointment-list spacing-top">
          @for (dto of selectedAppointments; track dto.dto!.id) {
            <div class="body-text">{{ getFormatedDate(dto.dto!) }}</div>
          }
        </div>
        <div class="left-aligned spacing-top">
          <app-text-button (click)="back()" [text]="'button.change' | transloco" colorVariant="tertiary" leadingIcon="edit" type="rounded"/>
        </div>

        <div class="typo-h1 spacing-top">{{ (selectedAppointments.length > 1 ? 'courses.confirminfos' : 'courses.confirminfo') | transloco }}</div>
        <div class="body-text-bold spacing-top">{{ "booking.confirm.label.bookingMessage" | transloco }}</div>
        <mat-form-field class="spacing-top-small">
          <textarea [formControl]="bookingMessageForm" [placeholder]="'form.placeholder.text' | transloco" matInput rows="4"></textarea>
        </mat-form-field>

        @if (errors.length > 0) {
          @for (dto of errors; track dto) {
            <mat-error>{{ dto }}</mat-error>
          }
        }

        <div class="fixed spacing-top">
          <div class="inner-row">
            <app-text-button (click)="book()" [text]="(selectedAppointments.length > 1 ? 'courses.bookmulti' : 'courses.book') | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
            <app-text-button (click)="cancel()" [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close" type="rounded"></app-text-button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="dialog-container">
      <div class="page-row-blank">
        <div class="column">
          <app-logo/>
          <div class="typo-h1 spacing-top">{{ 'courses.selection' | transloco }}</div>
          <div class="card-image-container spacing-top">
            @if (course.imageUrl != null) {
              <img src="{{course.imageUrl}}" alt="course"/>
            }
            <div class="card-price-tag">{{ course.price }} CHF</div>
          </div>
          <div class="typo-h1 spacing-top">{{ course.title }}</div>
          <div class="label spacing-top">
            <mat-icon>home</mat-icon>
            <div class="body-text-bold">{{ locationInfo() }}</div>
          </div>
          <div class="label spacing-top">
            <mat-icon>calendar_today</mat-icon>
            <div class="body-text-bold">{{ (selectedAppointments.length > 1 ? 'courses.appointments' : 'courses.appointment') | transloco }}
            </div>
          </div>
          <div class="appointment-list spacing-top">
            @for (dto of selectedAppointments; track dto.dto!.id) {
              <div class="body-text">{{ getFormatedDate(dto.dto!) }}</div>
            }
          </div>
          <div class="left-aligned spacing-top">
            <app-text-button (click)="back()" [text]="'button.change' | transloco" colorVariant="tertiary" leadingIcon="edit" type="rounded"/>
          </div>
        </div>
        <mat-divider class="primary" vertical/>
        <div class="list-column">
          <div class="typo-h1">{{ (selectedAppointments.length > 1 ? 'courses.confirminfos' : 'courses.confirminfo') | transloco }}</div>
          <div class="body-text-bold spacing-top">{{ "booking.confirm.label.bookingMessage" | transloco }}</div>
          <mat-form-field class="spacing-top-small">
            <textarea [formControl]="bookingMessageForm" [placeholder]="'form.placeholder.text' | transloco" matInput rows="4"></textarea>
          </mat-form-field>

          @if (errors.length > 0) {
            @for (dto of errors; track dto) {
              <mat-error>{{ dto }}</mat-error>
            }
          }

          <div class="fixed spacing-top">
            <div class="inner-row">
              <app-text-button (click)="book()" [text]="(selectedAppointments.length > 1 ? 'courses.bookmulti' : 'courses.book') | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
              <app-text-button (click)="cancel()" [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close" type="rounded"></app-text-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
